import type { FC } from 'react'

import { Image } from '@skytech/ui/Image'
import { useNavigate } from 'react-router-dom'

import { APP_ROUTES } from '@/util/app-routes'
import { imagePlaceholder } from '@/util/misc'

import type { Asset as AssetType } from '../../../resources'

import './AssetListItem.styles.scss'

const AssetListItem: FC<AssetType & { searchFilter: string }> = ({
  assetDescription,
  id,
  imageUrl,
}) => {
  const navigate = useNavigate()

  return (
    <button
      className="cost-object-details-asset"
      onClick={() => navigate(APP_ROUTES.HARDWARE_ASSET.replace(':id', String(id)))}
    >
      <div className="asset-name">
        <h4>{assetDescription}</h4>
      </div>
      <Image alt="asset" src={imageUrl || ''} className="asset-image" onError={imagePlaceholder} />
    </button>
  )
}

export default AssetListItem
